import Asset from "@/models/Asset";
import ClipArea from "@/models/ClipArea";
import Model from "@/models/Model";

export default class PrintArea extends Model {
  static type = "printAreas";

  customizationCoords: { x: number; y: number }[];
  maskImage: any;
	componentId: string;
	watermark: Asset;
	watermarkXPercentage: number;
	watermarkYPercentage: number;
	watermarkRotation: number;
	watermarkScalePercentage: number;
  defaultTextColor: string;
  name: string;
  textureScaleX: number;
  textureScaleY: number;
  textureRotation: number;
  zoomByDefault: boolean;
  textureOffsetX: number;
  scaleFactor: number;
  textureOffsetY: number;
  defaultBackgroundColor: string;

  get width(): number{
    return this.clipArea?.width||null;
  }

  get height(): number{
    return this.clipArea?.height||null;
  }

  get clipArea(): ClipArea {
		if(!this.customizationCoords){
			return null;
		}
    const minX = Math.min(...this.customizationCoords.map((o) => o.x));
    const minY = Math.min(...this.customizationCoords.map((o) => o.y));
    const maxX = Math.max(...this.customizationCoords.map((o) => o.x));
    const maxY = Math.max(...this.customizationCoords.map((o) => o.y));

    const coords = {
      x: minX,
      y: minY,
      width: maxX - minX,
      height: maxY - minY,
    };
    return coords;
  }
}
